<template>
  <main>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: './visa' }">签证</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: './visa_list' }">签证列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{ info.Name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <figure class="head">
      <img src="http://tp.cstravel.cn/ImageUpload/VisaProduct/VisaProduct/20161108/d16a22b21e954d2fb4c5257f7bb26ee6_6.jpg" alt=""/>
      <div class="info">
        <h3>{{ info.Name }}</h3>
        <div class="tag">
          <el-tag v-for='v in info.serves' :key="v" type="warning">{{ v }}</el-tag>
        </div>
        <ul>
          <li><span>签证类别：</span><b>{{ info.KindName }}</b></li>
          <li><span>签证形式：</span><b>{{ info.FormName }}</b></li>
          <li><span>受理地区：</span><b>{{ info.ReceivingArea }}</b></li>
        </ul>
      </div>
      <p class="price"><span>{{ getPrice }}</span><button class="btn" @click="placeAnOrder">立即预定</button></p>
    </figure>
    <ul class="submit">
      <li>
        <span>出行日期：</span>
        <el-date-picker
          type="date"
          ref="day"
          v-model="submit.day"
          value-format="yyyy-MM-dd"
          :picker-options="dayOptions"
          placeholder="选择日期">
        </el-date-picker>
      </li>
      <li>
        <span>套餐选择：</span>
        <nav>
          <a 
            :class="{ on: ~~info.meal === i }" 
            v-for="(v, i) in info.visa_prices" :key="v.Id"
            @click="info.meal = i">
            <span>{{ v.Name }}</span><b>（办理周期：{{ v | getCycle }}）</b>
          </a>
        </nav>
      </li>
      <li>
        <span>购买份数：</span>
        <el-input-number v-model="submit.count" :min="1" label="份数"></el-input-number>
      </li>
    </ul>
    <ul class="list">
      <li><span>入境次数</span><b>{{ info.AllowNums }}</b></li>
      <li><span>停留天数</span><b>{{ info.StayDays }}</b></li>
      <li><span>有效期</span><b>{{ info.ExpiryDays }}</b></li>
      <li><span>是否面签</span><b>{{ info.IfFace | getTypeDesc }}</b></li>
      <li><span>是否打指模</span><b>{{ info.IfFinger | getTypeDesc }}</b></li>
    </ul>
    <div class="cont">
      <el-menu 
        :default-active="menuIndex" 
        class="nav" 
        background-color
        mode="horizontal"
        @select="changeDescIndex">
        <el-menu-item index="0">套餐说明</el-menu-item>
        <el-menu-item index="1">所需资料</el-menu-item>
        <el-menu-item index="2">温馨提示</el-menu-item>
        <el-menu-item index="3">样板展示</el-menu-item>
      </el-menu>
      <ul class="box">
        <li>
          <h5 class="title">
            <i class="icon-duanlashuoming"></i>
            <span>套餐说明</span>
          </h5>
          <div class="content" v-html="info.PackageNote"></div>
        </li>
        <li>
          <h5 class="title">
            <i class="icon-ziliao"></i>
            <span>所需资料</span>
          </h5>
          <div class="info">
            <el-menu 
              :default-active="info.materialIndex" 
              class="el-menu-demo" 
              background-color
              size="small"
              mode="horizontal"
              @select="changeMaterialIndex">
              <el-menu-item index="0">在职人员</el-menu-item>
              <el-menu-item index="1">退休</el-menu-item>
              <el-menu-item index="2">自由职业</el-menu-item>
              <el-menu-item index="3">学生</el-menu-item>
              <el-menu-item index="4">学龄前儿童</el-menu-item>
            </el-menu>
            <ul class="info_list">
              <li v-for="(v, i) in info.material[info.materialIndex]" :key="i">
                <span>{{ v.Name }}</span>
                <a 
                  :class="{ has: !!v.FileUrl }" 
                  :href="v.FileUrl" 
                  :download="v.Name"
                  target="_blank">下载资料</a>
                <p v-html="v.Descs"></p>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <h5 class="title">
            <i class="icon-tishi"></i>
            <span>温馨提示</span>
          </h5>
          <div class="content" v-html="info.Reminder"></div>
        </li>
        <li>
          <h5 class="title">
            <i class="icon-duibi"></i>
            <span>样板展示</span>
          </h5>
          <div class="content">
            <img v-for="v in info.visa_models" :key="v.VisaModelID" :src="v.ImgUrl" alt=""/>
          </div>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import moment from 'moment';
import $strategy from '@assets/js/strategy';
export default {
  data () {
    return {
      menuIndex: '1',
      // 详情信息
      info: {
        material: [],
        materialIndex: '0'
      },
      // 提交信息
      submit: {
        day: null, // 出行日期
        count: 1, // 购买份数
        meal: 0, // 套餐选择 
      },
      dayOptions: {
        // 出行日期限制，非周末，叠加工作日
        disabledDate: date => {
          if ( moment(date).format('E') > 5 ) { return true; }
          const { meal, visa_prices: visa } = this.info;
          const e = ~~moment().format('E'); // 当前的星期数
          const addDay = ~~visa[meal].ProcessingDays; // 需要添加的工作日
          let startDate = null; // 可以开始选择的日期
          if ( e + addDay < 6 ) {
            // 不需要补足周末
            startDate = moment().add(addDay + 1, 'd' );
          } else {
            // 需要补足周末
            let weekCount = 0; // 需要补足的周末天数
            let add = addDay;
            add = add - (6 - e);
            weekCount += 2;
            weekCount += (Math.floor(add / 5) * 2);
            startDate = moment().add(addDay+weekCount, 'd' );
          }
          return Date.parse(startDate) > Date.parse(date);
        }
      }
    }
  },
  created () {
    // 平滑滚动到顶部
    window.scrollTo({ 
      top: 0, 
      behavior: "smooth" 
    });
    const info = this.$route.query;
    const { id, mealId } = info;
    // 无参返回
    if ( !id ) { this.$router.push({ name: 'visa' }); return; }
    this.getDetail(id, mealId);
  },
  mounted () {
    // 监听滚动切换导航
    const item = document.querySelector('.cont .box').childNodes;
    const h = [...item].reduce((arr, v) => {
      arr.push(v.offsetTop);
      return arr;
    }, []);

    window.addEventListener('scroll', (e) => {
      const top = document.documentElement.scrollTop;
      let index;
      for( let i = 0, len = h.length; i < len; i++ ) {
        if ( top < h[i] ) {
          index = i - 1;
          break;
        }
      }
      index === -1 && (index = 0);
      index === undefined && (index = h.length - 1);
      this.menuIndex = index.toString();
    })
  },
  computed: {
    getPrice () {
      const { meal, visa_prices: visa } = this.info;
      const attr = this.getPriceName();
      return visa ? (Number(visa[meal][attr]) || '') : '';
    }
  },
  filters: {
    getCycle (v) {
      const day = ~~v.ProcessingDays;
      let res;
      if ( day === 0 ) { res = '0~1个工作日' }
      else if ( day < 4 ) { res = `${day - 1}~${day}个工作日` }
      else if ( day >= 4 ) { res = `${day - 2}~${day}个工作日` }
      return res;
    },
    getTypeDesc (index) {
      const types = ['是', '否', '抽查'];
      return types[index] || index;
    }
  },
  methods: {
    // 下单
    placeAnOrder () {
      const { day, count } = this.submit;
      const { meal } = this.info;
      if ( $strategy.check(day, 'isEmpty') ) {
        this.$message.warning('请选择出行日期！');
        this.$refs.day.focus();
        return;
      }
      const { visa_prices, visa_ins } = this.info;
      this.$router.push({ 
        name: 'order_add', 
        params: { 
          info: this.info,
          order: visa_prices[meal], 
          ins: visa_ins, 
          day, count 
        } 
      });
    },
    // 切换详情索引
    changeDescIndex (value) {
      const item = document.querySelector('.cont .box').childNodes[value]; // 指定元素
      const valve = 20; // 阀值
      const boxHeight = document.querySelector('.cont .nav').clientHeight + valve; // 导航高度
      window.scrollTo({ top: item.offsetTop - boxHeight, behavior: 'smooth' });
    },
    changeMaterialIndex (value) {
      this.info = { ...this.info, materialIndex: value };
    },
    // 获取详情
    getDetail (id, mealId) {
      this.$axios.get(`/VisaProduct/detail/${id}`).then(({ product }) => {
        let info = product;
        // 服务承诺
        info.serves = info.Promise.split(',').filter(v => !!v);
        // 设置选中套餐
        let meal = 0;
        if ( mealId ) {
          const index = info.visa_prices.findIndex(v => v.Id === mealId);
          index !== -1 && (meal = index);
        }
        // 所需资料
        const material = info.visa_files.reduce((arr, v) => {
          const { TypeName } = v;
          arr[TypeName].push(v);
          return arr;
        }, [[],[],[],[],[]]);
        info.material = material;
        info.materialIndex = '0';

        info.meal = meal;
        this.info = info;
        this.setTitle(info.Name);
      })
    }
  }
}
</script>

<style scoped src="./detail.css"></style>